import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setIntegrationNameToAddReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.integrationNameToAdd = action.payload;
  });
};

export default setIntegrationNameToAddReducer;
